import React from 'react';

import NewDashboard from '../../components/NewDashboard';

function NewDashboardView() {
  return (
    <NewDashboard />
  );
}

export default NewDashboardView; 